import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';
import buttonStyles from '../button/index.module.css';

import ArrowButton, { DIRECTIONS } from '@components/common/arrow-button';
import utils from '@utils';

const DEFAULT_CONFIG = {
  delta: 5,
};

class Scroll extends Component {
  static get ORIENTATION() {
    return {
      VERTICAL: 'vertical',
      HORIZONTAL: 'horizontal',
    };
  }

  constructor(props) {
    super(props);

    this.spaceRef = React.createRef();
    this.anchorRef = React.createRef();
    this.state = { pos: 0, grabbed: false };
    this.onScrollStop = this.onScrollStop.bind(this);
    this.onScrollMove = this.onScrollMove.bind(this);
  }

  onScrollStart(event) {
    event.preventDefault();
    const anchorBox = this.anchorRef.current.getBoundingClientRect();
    const cursorPosition = utils.getCursorPosition(event);

    this.setState({
      grabbed: {
        left: cursorPosition.cx - anchorBox.left,
        top: cursorPosition.cy - anchorBox.top,
      },
    });
    document.addEventListener(utils.events.mouseup, this.onScrollStop);
    document.addEventListener(utils.events.mousemove, this.onScrollMove);
  }

  onScrollStop() {
    this.setState({ grabbed: false });
    document.removeEventListener(utils.events.mouseup, this.onScrollStop);
    document.removeEventListener(utils.events.mousemove, this.onScrollMove);
  }

  onScrollMove(event) {
    event.preventDefault();

    const spaceBox = this.spaceRef.current.getBoundingClientRect();
    const anchorBox = this.anchorRef.current.getBoundingClientRect();
    const isVert = this.props.orientation === Scroll.ORIENTATION.VERTICAL;
    const top = isVert ? 'top' : 'left';
    const height = isVert ? 'height' : 'width';
    const cursorPosition = utils.getCursorPosition(event);
    const movePoint = {
      left: cursorPosition.cx - spaceBox.left - this.state.grabbed.left,
      top: cursorPosition.cy - spaceBox.top - this.state.grabbed.top,
    };
    const space = spaceBox[height] - anchorBox[height];
    let pos = (100 * movePoint[top]) / space;

    if (pos < 0) {
      pos = 0;
    } else if (pos > 100) {
      pos = 100;
    }

    this.setState({ pos });
    if (this.props.onChange) {
      this.props.onChange(pos);
    }
  }

  componentDidMount() {
    this.anchorRef.current.style.height = this.props.size + '%';

    this.anchorRef.current.addEventListener(
      utils.events.mousedown,
      this.onScrollStart.bind(this),
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.pos !== prevProps.pos && this.props.pos !== this.state.pos) {
      this.setState({ pos: this.props.pos });
    }
  }

  onArrowClick(index) {
    let pos = this.state.pos + DEFAULT_CONFIG.delta * (index === 0 ? -1 : 1);

    if (pos < 0) {
      pos = 0;
    } else if (pos > 100) {
      pos = 100;
    }
    this.setState({ pos });
    if (this.props.onChange) {
      this.props.onChange(pos);
    }
  }

  render() {
    const { pos } = this.state;
    const { orientation, disabled, className, light } = this.props;
    const isVert = orientation === Scroll.ORIENTATION.VERTICAL;
    const height = isVert ? 'height' : 'width';

    return (
      <div
        className={`${styles.container} ${className} ${
          isVert ? styles.vertical : styles.horizontal
        } ${disabled ? styles.disabled : ''} ${light ? styles.light : ''}`}>
        <ArrowButton
          disabled={disabled}
          className={styles.firstArrow}
          onClick={this.onArrowClick.bind(this, 0)}
          light={light}
          direction={isVert ? DIRECTIONS.UP : DIRECTIONS.LEFT}
        />
        <ArrowButton
          disabled={disabled}
          className={styles.secondArrow}
          onClick={this.onArrowClick.bind(this, 1)}
          light={light}
          direction={isVert ? DIRECTIONS.DOWN : DIRECTIONS.RIGHT}
        />
        <div ref={this.spaceRef} className={styles.space}>
          <button
            style={{
              [isVert ? 'top' : 'left']: `${((100 - this.props.size) * pos) /
                100}%`,
              [height]: this.props.size + '%',
            }}
            className={`${buttonStyles.button} ${styles.anchor} ${
              light ? buttonStyles.light : ''
            }`}
            ref={this.anchorRef}
          />
        </div>
      </div>
    );
  }
}

Scroll.defaultProps = {
  orientation: Scroll.ORIENTATION.VERTICAL,
  className: '',
  size: 30,
  value: -1,
  onChange: false,
  disabled: false,
  light: false,
};

Scroll.propTypes = {
  orientation: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  light: PropTypes.bool,
};

export default Scroll;
